var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3196 3.99756C8.14987 3.99756 4.875 6.93638 4.47165 10.9976C4.42525 11.4647 3.91142 12.0262 3.33867 11.9494C2.84032 11.8826 2.45101 11.3217 2.49741 10.8546C2.98631 5.93209 7.26782 1.99756 12.3196 1.99756C16.3156 1.99756 19.7479 4.55262 21.2505 7.9905C21.4385 8.42066 21.3449 9.05241 20.8781 9.32846C20.3628 9.63314 19.6192 9.25251 19.4312 8.82236C18.1895 5.98147 15.6161 3.99756 12.3196 3.99756Z",
    fill: "#226DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3618 3.00357C21.9083 2.96253 22.3499 3.53058 22.3499 4.00002V8.40002C22.3499 9.20084 21.7007 9.85002 20.8999 9.85002H16.4999C16.0304 9.85002 15.6851 9.46815 15.6499 9.00002C15.6117 8.49245 16.0304 8.01192 16.4999 8.01192H20.5118V4.00002C20.5118 3.53058 20.8517 3.04186 21.3618 3.00357Z",
    fill: "#226DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6521 20.0039C16.8218 20.0039 20.1119 16.9772 20.5152 12.916C20.5616 12.4489 21.0734 12.1074 21.5838 12.1542C22.0901 12.2006 22.5416 12.6169 22.4952 13.084C22.0063 18.0065 17.7036 22 12.6518 22C8.65581 22 5.14628 19.5222 3.6437 16.0843C3.45569 15.6542 3.72919 15.0758 4.15935 14.8878C4.5895 14.6998 5.17373 14.813 5.36173 15.2432C6.60339 18.0841 9.35553 20.0039 12.6521 20.0039Z",
    fill: "#226DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62161 20.8499C3.11814 20.876 2.64997 20.4694 2.64997 19.9999V15.5999C2.64997 14.7991 3.29916 14.1499 4.09997 14.1499H7.49997C7.96942 14.1499 8.35402 14.5886 8.3501 15.081C8.34621 15.5691 7.96942 15.9972 7.49997 15.9972H4.49729V19.9999C4.49729 20.4694 4.09755 20.8252 3.62161 20.8499Z",
    fill: "#226DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.140a21fb77ea6f58f9f4cea695ab00ff.svg";
export { ForwardRef as ReactComponent };